export default __webpack_public_path__ + "static/media/1467.83ae9ad6.png";